import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import classNames  from 'classnames';
import pdf from 'images/pdf-icon.svg';

export default (props) => (
  <div to={`/topic/${props.data.slug}`} className={classNames('accordion-head')}>

    <Link to={`/topic/${props.data.slug}`}  className="accordion-head-caption" style={{width: '20%'}}>
      {/* <span className="accordion-head-icons ic-play"/> */}
      <span className="accordion-head-label" style={{width: '150px'}}>{props.data.title}</span>
    </Link>
    {props.data.completed ?
      <div className="btn blue rounded" style={{width: '20%'}}>
        Successfully Completed
      </div> :
      <Link to={props.data.tutorial_type === 'ckt' ? `/quiz/${props.data.slug}` : `/topic/${props.data.slug}`} className="btn blue rounded" style={{width: '20%'}}>
        Take Quiz
      </Link>
    }
    {/* <span className="accordion-head-views tracking-wrapper-hide-on-mobile" style={{width: '20%'}}>
      CPD points {props.data.cpd_points} Ext
    </span>
    {props.data.completed ?
      <span className="accordion-head-views tracking-wrapper-hide-on-mobile" style={{width: '20%'}}>
          {`Completed ${moment(props.data.completed_at).format('DD/MM/YYYY')}`}
      </span> :
      <Link to={{
        pathname: `/topic/${props.data.tutorial.id}`,
        openQuiz: true
      }} className="accordion-head-views" style={{width: '20%'}}>
        {'Quiz not completed'}
      </Link>
    }
    {props.data.completed ?
      <a
        href={`https://prescriptionrevision.com/api/v1/pdfs/${props.data.tutorial.id}?token=${localStorage.getItem('token')}`}
        target='_blank'
      >
        <img src={pdf} alt="pdf" style={{marginRight: '10px'}} />
      </a> :
      <div className='tracking-wrapper-hide-on-mobile' style={{width: '30px'}}></div>
    } */}
  </div>
);



// WEBPACK FOOTER //
// ./src/modules/reimbursed/components/CollapseHead.js